export default "__VITE_ASSET__CBl0DU1v__"